import { takeLatest, put, call } from 'redux-saga/effects'
import { snackbarActions, studentConstants } from '../actions'
import { studentService } from '../services'

export function* getStudentInfo(action) {
    try {
        const getUserInfoResponse = yield call(studentService.getUserInfo, action.payload.appVersion)
        yield put({ type: studentConstants.STUDENT_GET_USER_INFO.SUCCESS, data: getUserInfoResponse.data })
    } catch (e) {
        yield put({ type: studentConstants.STUDENT_GET_USER_INFO.FAILURE })
        yield put(
            snackbarActions.enqueueSnackbar({
                message: 'Could not get user information.',
                options: {
                    variant: 'warning',
                },
            })
        )
    }
}

export function* getStudentLanguageMetadata(action) {
    try {
        const getUserInfoResponse = yield call(studentService.getUserLanguageMetadata)
        yield put({ type: studentConstants.STUDENT_METADATA.SUCCESS, data: getUserInfoResponse.data })
    } catch (e) {
        yield put({ type: studentConstants.STUDENT_METADATA.FAILURE })
        yield put(
            snackbarActions.enqueueSnackbar({
                message: 'Could not get language metadata.',
                options: {
                    variant: 'warning',
                },
            })
        )
    }
}

export function* changeStudentAppLanguage(action) {
    try {
        const changeLanguageResponse = yield call(studentService.changeAppLanguage, action.payload)
        yield put({
            type: studentConstants.STUDENT_CHANGE_APP_LANGUAGE.SUCCESS,
            data: changeLanguageResponse.data,
        })
        yield put({ type: studentConstants.STUDENT_GET_USER_INFO.REQUEST, payload: { appVersion: 'web' } })
    } catch (e) {
        yield put({ type: studentConstants.STUDENT_CHANGE_APP_LANGUAGE.FAILURE })
        yield put(
            snackbarActions.enqueueSnackbar({
                message: 'Could not change app language.',
                options: {
                    variant: 'warning',
                },
            })
        )
    }
}

export function* createSelfAccessCode(action) {
    try {
        const response = yield call(studentService.createSelfAccessCode)
        yield put({ type: studentConstants.STUDENT_CREATE_SELF_ACCESS_CODE.SUCCESS, data: response.data })
    } catch (e) {
        yield put({ type: studentConstants.STUDENT_CREATE_SELF_ACCESS_CODE.FAILURE })
        yield put(
            snackbarActions.enqueueSnackbar({
                message: 'Could not generate access code. Please try again.',
                options: { variant: 'warning' },
            })
        )
    }
}

export function* setPassword(action) {
    try {
        const response = yield call(studentService.setPassword, action.payload)
        yield put({ type: studentConstants.STUDENT_SET_PASSWORD.SUCCESS, data: response.data })
        yield put(
            snackbarActions.enqueueSnackbar({
                message: 'Password has been set successfully.',
                options: { variant: 'success' },
            })
        )
    } catch (e) {
        yield put({ type: studentConstants.STUDENT_SET_PASSWORD.FAILURE })
        yield put(
            snackbarActions.enqueueSnackbar({
                message: 'Could not set password. Please try again.',
                options: { variant: 'warning' },
            })
        )
    }
}

export function* studentSagas() {
    yield takeLatest(studentConstants.STUDENT_GET_USER_INFO.REQUEST, getStudentInfo)
    yield takeLatest(studentConstants.STUDENT_METADATA.REQUEST, getStudentLanguageMetadata)
    yield takeLatest(studentConstants.STUDENT_CHANGE_APP_LANGUAGE.REQUEST, changeStudentAppLanguage)
    yield takeLatest(studentConstants.STUDENT_CREATE_SELF_ACCESS_CODE.REQUEST, createSelfAccessCode)
    yield takeLatest(studentConstants.STUDENT_SET_PASSWORD.REQUEST, setPassword)
}
